<template>
  <PageWrapper>
    <NavbarMain />
    <BaseAlertMessage />
    <OpportunityListWrapper ref="oplWrapper" :meta="meta" />
    <Footer />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import NavbarMain from '@/components/_shared/navbar-main/NavbarMain.vue'
import Footer from '@/components/_shared/Footer.vue'

import OpportunityListWrapper from '@/components/opportunity-list/OpportunityListWrapper.vue'

export default {
  name: 'Opportunities',
  props: {
    meta: {
      type: Object,
      required: true
    }
  },
  components: {
    PageWrapper,
    NavbarMain,
    Footer,
    OpportunityListWrapper
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.oplWrapper && this.$refs.oplWrapper.$refs.oplSearch) {
      this.$refs.oplWrapper.$refs.oplSearch.cleanSearch();
    }
    if (this.$refs.oplWrapper && this.$refs.oplWrapper.$refs.oplPagination) {
      this.$refs.oplWrapper.$refs.oplPagination.cleanPages();
    }
    next();
  }
}
</script>
